import { NextSeo, NextSeoProps } from 'next-seo'

export const Seo: React.FC<NextSeoProps> = ({
  title,
  description,
  openGraph,
  ...props
}) => {
  return (
    <NextSeo
      title={title}
      description={description}
      openGraph={{
        title,
        description,
        ...openGraph,
      }}
      {...props}
    />
  )
}
